export default "__VITE_ASSET__BIt_LhJc__"